














































































import XModal from '@/components/atoms/Modal/XModal.vue'
import XIcon from '@/components/atoms/Icon/XIcon.vue'
import XConfirm from '@/components/atoms/Confirm/XConfirm.vue'
import confirmMixin from '@/mixin/confirmMixin'
import creditCardQuery from '@/graphql/user/creditCard.gql'
import salesProductsQuery from '@/graphql/product/salesProducts.gql'
import {
  CreditCard,
  GoodsSeries,
  Partner,
  PartnerServiceContract,
  PaymentMethod,
  ProductContract,
  Query,
  ServiceGoodsSeries,
  StoreSalesGoods,
} from '@/types/generated/graphql'
import FfGoodsItem from '@/components/molecules/FfGoods/FfGoodsItem.vue'
import GoodsSeriesTab from '@/components/molecules/FfGoods/GoodsSeriesTab.vue'
import OrderConfirmation from '@/components/molecules/FfGoods/OrderConfirmation.vue'
import { PropType } from 'vue'

type Data = {
  salesFfGoodsWithQuantityList: Array<SalesFfGoodsWithQuantity>
  selectedSeries: string | null
  orderingSalesFfGoodsWithQuantity: SalesFfGoodsWithQuantity | null
  creditCard: CreditCard | null
  modalShow: boolean
  showOrderCompleted: boolean
}

type Methods = {
  onOrderBefore: (callback: () => void) => void
  onDoneOrder: () => Promise<void>
  onOrder: (salesFfGoodsWithQuantity: SalesFfGoodsWithQuantity) => Promise<void>
  seriesFilter: (goodsSeriesId: string) => void
  resetFilter: () => void
}

type Computed = {
  selectedSalesFfGoodsWithQuantityList: Array<SalesFfGoodsWithQuantity>
  canOrder: boolean
  isCardAvailable: boolean
  goodsSerieses: GoodsSeries[]
}

type Props = {
  partner: Partner
  serviceContract: PartnerServiceContract
}

type SalesFfGoodsWithQuantity = {
  salesFfGoods: StoreSalesGoods
  quantity: number
}

export default confirmMixin.extend<Data, Methods, Computed, Props>({
  name: 'FfGoodsList',
  mixins: [confirmMixin],
  components: {
    XModal,
    XIcon,
    XConfirm,
    FfGoodsItem,
    GoodsSeriesTab,
    OrderConfirmation,
  },
  props: {
    partner: {
      type: Object as PropType<Partner>,
      required: true,
    },
    serviceContract: {
      type: Object as PropType<PartnerServiceContract>,
    },
  },
  data() {
    return {
      salesFfGoodsWithQuantityList: [],
      selectedSeries: null,
      orderingSalesFfGoodsWithQuantity: null,
      creditCard: null,
      showOrderCompleted: false,
      modalShow: false,
    }
  },
  computed: {
    selectedSalesFfGoodsWithQuantityList(): Array<SalesFfGoodsWithQuantity> {
      if (this.selectedSeries === null) {
        return this.salesFfGoodsWithQuantityList
      }
      return this.salesFfGoodsWithQuantityList.filter(
        (salesFfGoods) =>
          salesFfGoods.salesFfGoods.product.goodsSpec.goodsSeriesId ===
          this.selectedSeries
      )
    },
    canOrder() {
      return (
        (this.partner.paymentMethod === PaymentMethod.Credit &&
          this.isCardAvailable) ||
        this.partner.paymentMethod === PaymentMethod.Bank
      )
    },
    isCardAvailable() {
      return this.creditCard !== null
    },
    goodsSerieses() {
      const goodsSerieses = this.serviceContract.productContracts?.reduce(
        (acc: GoodsSeries[], pc: ProductContract) => {
          const { goodsSeries } = pc.serviceProduct as ServiceGoodsSeries
          return goodsSeries ? [...acc, goodsSeries] : acc
        },
        []
      )
      return goodsSerieses || []
    },
  },
  methods: {
    async onOrderBefore(callback) {
      this.showConfirm({
        okHandler: async () => {
          await callback()
        },
      })
    },
    async onDoneOrder() {
      this.modalShow = false
      await this.$apollo.queries.searchSalesFfGoods.refetch()
      this.showOrderCompleted = true
    },
    async onOrder(
      salesFfGoodsWithQuantity: SalesFfGoodsWithQuantity
    ): Promise<void> {
      this.orderingSalesFfGoodsWithQuantity = salesFfGoodsWithQuantity

      this.modalShow = true
    },
    seriesFilter(goodsSeriesId) {
      this.selectedSeries = goodsSeriesId
    },
    resetFilter() {
      this.selectedSeries = null
    },
  },
  apollo: {
    fetchCreditCardToken: {
      query: creditCardQuery,
      update({ creditCard }): void {
        this.creditCard = creditCard
      },
    },
    searchSalesFfGoods: {
      query: salesProductsQuery,
      fetchPolicy: 'network-only',
      variables() {
        return {
          input: {
            partnerServiceContractId: this.serviceContract
              .partnerServiceContractId,
          },
          withMenu: false,
        }
      },
      update({ salesProducts }: Query): void {
        const publishedGoods = salesProducts.filter(
          (salesGoods) => salesGoods.product.published
        )
        this.salesFfGoodsWithQuantityList = publishedGoods.map(
          (salesFfGoods) => {
            return {
              salesFfGoods: salesFfGoods as StoreSalesGoods,
              quantity: 0,
            }
          }
        )
      },
    },
  },
})
